var C;(function(C){C["ASC"]="ASC";C["DESC"]="DESC";C["NONE"]="NONE"})(C||(C={}));var A;(function(C){C["STATIC"]="STATIC";C["ACTIVE"]="ACTIVE"})(A||(A={}));export{C as EOrderByDirection,A as ETableMode};
//# sourceMappingURL=enums.js.map
